import { TableCell, TableRow } from '@mui/material';
import { FC, useContext } from 'react';
import { MarketStore } from '../../../app/services/api/orderManagementClient';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../../../components/shared/useUser';

type Props = {
  item: MarketStore;
};

const StoreItemRow: FC<Props> = ({ item }) => {
  const { t } = useTranslation('stores');
  const navigate = useNavigate();
  const { hasPermissionTo } = useContext(UserContext);

  const canEdit = hasPermissionTo(['ConfigurationAdmin']) || hasPermissionTo(['StoreUpdate']);

  const handleRowClick = () => {
    if (!canEdit) return;
    navigate(`/stores/edit/${item.customerId}`);
  };

  return (
    <TableRow 
      onClick={canEdit ? handleRowClick : undefined}
      sx={{ 
        cursor: canEdit ? 'pointer' : 'default',
        '&:hover': canEdit ? {
          backgroundColor: 'action.hover',
        } : undefined,
      }}
    >
      <TableCell>
        {item.storeName}
      </TableCell>
      <TableCell>
        {item.marketName}
      </TableCell>
      <TableCell>
        {item.instanceName}
      </TableCell>
      <TableCell>
        {item.inventoryEnabled ? t('yes') : t('no')}
      </TableCell>
      <TableCell>
        {item.inventoryStartDate}
      </TableCell>
    </TableRow>
  );
};

export default StoreItemRow;
